import { render, staticRenderFns } from "./AddCourseForStudent.vue?vue&type=template&id=e93b5cec&scoped=true&"
import script from "./AddCourseForStudent.vue?vue&type=script&lang=js&"
export * from "./AddCourseForStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93b5cec",
  null
  
)

export default component.exports